var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("E")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Excel")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("P")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-pdf-o" }),
                _c("span", [_vm._v("PDF")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-8" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "H" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "A" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaDesde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaDesde", $$v)
                            },
                            expression: "form.fechaDesde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Desde:")])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaHasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaHasta", $$v)
                            },
                            expression: "form.fechaHasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Hasta:")])
                      ],
                      1
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2 select2-field--stretch",
                  class: { "select2--disabled": !_vm.administraTodasBodegas }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.optionsBodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal:")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-9" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        filterable: false,
                        label: "nombre",
                        placeholder: "Seleccione...",
                        options: _vm.optionsUsuarios,
                        id: "usuarios",
                        multiple: ""
                      },
                      on: {
                        search: _vm.onSearchUsuarios,
                        input: _vm.inputUsuarios
                      },
                      model: {
                        value: _vm.selectedUsuarios,
                        callback: function($$v) {
                          _vm.selectedUsuarios = $$v
                        },
                        expression: "selectedUsuarios"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "usuarios" } }, [
                      _vm._v("Recaudadores:")
                    ])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.registros.length > 0
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c("h6", [
                      _vm._v(
                        _vm._s(
                          (_vm.nombreBodega != null && _vm.nombreBodega != ""
                            ? "SUCURSAL: " + _vm.nombreBodega + " | "
                            : "") +
                            "Total: " +
                            _vm.total
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    { staticClass: "table-responsive" },
                    [
                      _c("vue-good-table", {
                        attrs: {
                          columns: _vm.columns,
                          "pagination-options": {
                            enabled: true,
                            perPage: 15,
                            perPageDropdown: _vm.dropDown,
                            nextLabel: "siguiente",
                            prevLabel: "anterior",
                            rowsPerPageLabel: "Registros por página",
                            ofLabel: "de",
                            allLabel: "Todo",
                            dropdownAllowAll: true
                          },
                          rows: _vm.registros,
                          "search-options": {
                            enabled: true,
                            placeholder: "Buscar..."
                          },
                          styleClass: "vgt-table vgt-table--sticky"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-row",
                              fn: function(props) {
                                return [
                                  props.column.field == "numero_cartilla"
                                    ? _c("span", [
                                        _c("span", [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn-info btn--text",
                                              attrs: { type: "button" },
                                              on: {
                                                dblclick: function($event) {
                                                  return _vm.verCartilla(
                                                    props.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.formattedRow[
                                                      props.column.field
                                                    ]
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              props.formattedRow[
                                                props.column.field
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3198975390
                        )
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "ac" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Informe de arqueo de caja")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8e521a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8e521a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteArqueoCaja.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d8e521a2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteArqueoCaja.vue
// module chunks = 0